var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iScroll",staticClass:"infinite-scroll",class:_vm.data.length ? '' : 'centered'},[(_vm.data.length)?_vm._t("default",null,{"data":_vm.data}):_vm._e(),(
      !_vm.paused &&
      ((_vm.totalLoaded < _vm.total_items && _vm.totalLoaded >= _vm.perPage) || _vm.oLoading)
    )?_c('div',{staticClass:"loading",class:_vm.oLoading ? 'full-height' : ''},[_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)]):(!_vm.oLoading && !_vm.data.length)?_c('Empty'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }